import { createSelector } from 'reselect';

const selectSheduleAuditLogs = (state: any) => state.sheduleAuditLogs;


export const selectSheduleAuditLogsCurrentItem = createSelector([selectSheduleAuditLogs], (sheduleAuditLogs) => sheduleAuditLogs.current);

export const selectSheduleAuditLogsListItems = createSelector([selectSheduleAuditLogs], (sheduleAuditLogs) => sheduleAuditLogs.list);

export const selectSheduleAuditLogsItemById = (itemId: any) =>
    createSelector(selectSheduleAuditLogsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSheduleAuditLogsCreatedItem = createSelector([selectSheduleAuditLogs], (sheduleAuditLogs) => sheduleAuditLogs.create);

export const selectSheduleAuditLogsUpdatedItem = createSelector([selectSheduleAuditLogs], (sheduleAuditLogs) => sheduleAuditLogs.update);

export const selectSheduleAuditLogsReadItem = createSelector([selectSheduleAuditLogs], (sheduleAuditLogs) => sheduleAuditLogs.read);

export const selectSheduleAuditLogsDeletedItem = createSelector([selectSheduleAuditLogs], (sheduleAuditLogs) => sheduleAuditLogs.delete);

export const selectRolesSearchedItems = createSelector([selectSheduleAuditLogs], (sheduleAuditLogs) => sheduleAuditLogs.search);

export const selectSheduleAuditLogsItemsCount = createSelector([selectSheduleAuditLogs], (sheduleAuditLogs) => sheduleAuditLogs.count);

export const selectSheduleAuditLogsItemsFilter = createSelector([selectSheduleAuditLogs], (sheduleAuditLogs) => sheduleAuditLogs.filter);